import type { FortressKit, PetKit, RoadKit, TowerKit, TroopKit } from "../kit/types";
import { BRONZE } from "./bronze";
import { VERDIGRIS } from "./verdigris";
import { OBSIDIAN } from "./obsidian";
import { GILDED } from "./gilded";
import { IVORY } from "./ivory";
import { CRIMSON } from "./crimson";
import { IRONWOOD } from "./ironwood";
import { VOIDGLASS } from "./voidglass";
import { BORDERWARDEN } from "./borderwarden";
import { FORGEGUARD } from "./forgeguard";
import { WINTERHOLD } from "./winterhold";
import { THORNWARDEN } from "./thornwarden";
import { TIDEWRACK } from "./tidewrack";
import { SOVEREIGN } from "./sovereign";
import { MOONSTONE } from "./moonstone";
import { ROYAL } from "./royal";
import { NIGHTWATCH } from "./nightwatch";
import { SUNSTONE } from "./sunstone";
import { SLATE } from "./slate";
import { CAUSEWAY } from "./causeway";
import { RUNESTONE } from "./runestone";
import { STARFALL_KITS } from "./starfall";
import { STARFALL_FORTRESS } from "./starfall_fortress";
import { DRAGONLORD } from "./dragonlord";
import { PET_KIT_LIST } from "./pets";

/**
 * Every skin kit by skin id (balance/src/shop.json ids). One file per skin so the skin authors never share a file;
 * a null entry is a skin not yet rebuilt as a kit, which keeps its legacy look from looks.ts.
 */
const byId = <K extends { id: string }>(list: readonly (K | null)[]): Readonly<Record<string, K>> =>
  Object.fromEntries(list.filter((k): k is K => k !== null).map((k) => [k.id, k]));

export const TOWER_KITS: Readonly<Record<string, TowerKit>> = byId([BRONZE, VERDIGRIS, OBSIDIAN, GILDED, IVORY, CRIMSON, IRONWOOD, VOIDGLASS, BORDERWARDEN, FORGEGUARD, WINTERHOLD, THORNWARDEN, TIDEWRACK, SOVEREIGN, ...STARFALL_KITS]);
export const FORTRESS_KITS: Readonly<Record<string, FortressKit>> = byId([DRAGONLORD, MOONSTONE, STARFALL_FORTRESS]);
export const TROOP_KITS: Readonly<Record<string, TroopKit>> = byId([ROYAL, NIGHTWATCH]);
export const ROAD_KITS: Readonly<Record<string, RoadKit>> = byId([SUNSTONE, SLATE, CAUSEWAY, RUNESTONE]);
export const PET_KITS: Readonly<Record<string, PetKit>> = byId(PET_KIT_LIST);
